import './success-cases.component.scss'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import Swiper, { Navigation, Pagination } from 'swiper'

class SuccessSlider {
  constructor(elements) {
    this.elements = elements

    this.init()
  }

  defineSlider() {
    new Swiper(this.elements.slider, {
      modules: [Navigation, Pagination],
      spaceBetween: 24,
      pagination: {
        el: this.elements.pagination,
        type: 'bullets',
        clickable: true
			},
			autoHeight: true,
      navigation: this.elements.navigation,
      breakpoints: {
        667: {
          slidesPerView: 1.5,
					autoHeight: false,
        },
        1024: {
					autoHeight: false,
          slidesPerView: 2,
        },
        1280: {
					autoHeight: false,
          slidesPerView: 2.5
        }
      }
    })
  }

  init() {
    this.defineSlider()
  }
}

const successSectionEl = document.querySelector('.success-cases')
if (successSectionEl) {
  const navigation = {
    prevEl: successSectionEl.querySelector('.success-cases__arrow_prev'),
    nextEl: successSectionEl.querySelector('.success-cases__arrow_next'),
  }

  const pagination = successSectionEl.querySelector('.swiper-pagination')

  const slider = successSectionEl.querySelector('.swiper')

  if (slider) {
    new SuccessSlider({
      slider,
      pagination,
      navigation
    })
  }
}
